// path image
export const imgPath = "storage/uploads/";

// depoly to serve
// export const domain_member = "https://update.tcdcconnect.com/member/";
// export const domain = "https://update.tcdcconnect.com/service/";
// export const domainFrontend = "https://update.tcdcconnect.com";

export const domain = "https://connect.cea.or.th/service/";
export const domain_member = "https://connect.cea.or.th/member/";
export const domainFrontend = "https://connect.cea.or.th";

// localhost
// export const domain = "http://127.0.0.1:8000/";
// export const domain_member = "http://127.0.0.1:8001/";
// export const domainFrontend = "https://tcdc-connect.kisrasprint.com";
